import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-payment-term',
  templateUrl: './add-payment-term.component.html',
  styleUrls: ['./add-payment-term.component.css']
})
export class AddPaymentTermComponent implements OnInit {

  paymentTermForm: any | FormGroup;
  cid: any

  termTypes = [
    { value: 'HOUR', viewValue: 'Hour' },
    { value: 'DAY', viewValue: 'Day' },
    { value: 'WEEK', viewValue: 'Week' },
    { value: 'MONTH', viewValue: 'Month' },
  ];


  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService
  ) { }
  
  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')

    this.paymentTermForm = this.fb.group({
      termName: ['',[Validators.required]],
      termValue: ['',[Validators.required]],
      termType: ['',[Validators.required]],
    });
  }



  addPaymentTerm(){

    if(!this.paymentTermForm.valid){
      this.toastr.error('please fill required fields');

      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "termName": this.paymentTermForm.get('termName').value,
      "termValue": this.paymentTermForm.get('termValue').value,
      "termType": this.paymentTermForm.get('termType').value,
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.addPaymentTerm(body).subscribe(
      (response:any) => {
        console.log(response)
        this.paymentTermForm.reset()
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )

  }


}

